import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Terms and Conditions</h1>

      <h2>1. Introduction</h2>
      <p>
        Welcome to NeoSapiens Neo&#39;1 product (&quot;Neo 1&quot;), your AI
        assistant. These Terms and Conditions (&quot;Terms&quot;) govern your
        access to and use of Neo 1, its app, wearable, and associated services
        (collectively, the &quot;Service&quot;). By using the Service, you agree
        to comply with and be bound by these Terms. If you do not agree to these
        Terms, you must discontinue use of the Service immediately.
      </p>

      <h2>2. Eligibility</h2>
      <ul>
        <li>• You must be at least 18 years old to use the Service.</li>
        <li>
          • By agreeing to these Terms, you represent and warrant that you have
          the authority to bind yourself or the entity you represent to these
          Terms.
        </li>
      </ul>

      <h2>3. Use of the Service</h2>
      <h3>3.1 License</h3>
      <p>
        NeoSapien grants you a non-exclusive, non-transferable, revocable
        license to use the Service solely for personal or business use in
        compliance with these Terms.
      </p>

      <h3>3.2 Restrictions</h3>
      <p>You agree not to:</p>
      <ul>
        <li>
          • Reverse engineer, decompile, or disassemble any part of the Service.
        </li>
        <li>
          • Use the Service for illegal, harmful, or unauthorized purposes.
        </li>
        <li>
          • Violate the intellectual property rights of NeoSapien or third
          parties.
        </li>
        <li>• Share your account credentials with others.</li>
      </ul>

      <h2>4. Privacy</h2>
      <p>
        Your use of Neo 1 is governed by our Privacy Policy. We collect and
        process data in compliance with the Information Technology (Reasonable
        Security Practices and Procedures and Sensitive Personal Data or
        Information) Rules, 2011.
      </p>

      <h2>5. Subscriptions and Payments</h2>
      <h3>5.1 Free Usage</h3>
      <ul>
        <li>• Neo 1 currently has no monthly subscription or hidden fees.</li>
        <li>
          • You can access every existing feature and receive all updates at no
          cost.
        </li>
      </ul>

      <h3>5.2 Payment Terms</h3>
      <ul>
        <li>
          • NeoSapien reserves the right to introduce and change subscription
          rates with prior notice.
        </li>
        <li>
          • You will be informed and must agree to any new rates before being
          charged.
        </li>
      </ul>

      <h2 id="cancellation">
        6. Pre-Booking, Shipping, Cancellation, Refunds, and Returns
      </h2>
      <h3>6.1 Pre-Booking</h3>
      <ul>
        <li>
          • Customers may pre-book Neo 1 by making a refundable advance payment
          as specified at the time of booking.
        </li>
        <li>
          • Pre-booking does not guarantee immediate availability and is subject
          to stock availability and manufacturing timelines.
        </li>
      </ul>

      <h3>6.2 Shipping</h3>
      <ul>
        <li>
          • Shipping timelines will be communicated at the time of purchase and
          may vary based on the delivery location.
        </li>
        <li>
          • NeoSapien is not liable for delays caused by courier services or
          unforeseen circumstances.
        </li>
      </ul>

      <h3>6.3 Cancellations</h3>
      <ul>
        <li>
          • Pre-bookings may be canceled prior to shipment. Refunds for
          cancellations will be processed within 7-10 business days.
        </li>
        <li>• Orders cannot be canceled once shipped.</li>
      </ul>

      <h3>6.4 Refunds</h3>
      <ul>
        <li>
          • Refunds are applicable only for defective products or as required by
          law.
        </li>
        <li>
          • Requests for refunds must be initiated within 7 days of delivery.
        </li>
      </ul>

      <h3>6.5 Returns</h3>
      <ul>
        <li>• Returns are accepted only for defective or damaged products.</li>
        <li>
          • Products must be returned in their original packaging with all
          accessories.
        </li>
        <li>
          • NeoSapien reserves the right to inspect returned items and deny a
          refund if the product shows signs of misuse or tampering.
        </li>
      </ul>

      <h2>7. Warranty Terms</h2>
      <ul>
        <li>• Neo 1 comes with a 1-year warranty from the date of delivery.</li>
        <li>
          • The warranty covers replacement of the device in case of damage
          under reasonable usage conditions.
        </li>
        <li>
          • The warranty does not cover damage caused by misuse, unauthorized
          modifications, or external factors such as accidents or natural
          disasters.
        </li>
      </ul>

      <h2>8. Intellectual Property</h2>
      <p>
        Neo 1 and all associated software, designs, trademarks, and content are
        the intellectual property of NeoSapien. Unauthorized use of these assets
        is strictly prohibited.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by Indian law, NeoSapien is not liable
        for:
      </p>
      <ul>
        <li>
          • Any indirect, incidental, or consequential damages arising out of
          your use of the Service.
        </li>
        <li>
          • Data loss, unauthorized access, or interruptions caused by third
          parties or your actions.
        </li>
      </ul>

      <h2>10. Warranty Disclaimer</h2>
      <p>
        The Service is provided &quot;as is&quot; without warranties of any
        kind, express or implied, including but not limited to warranties of
        merchantability, fitness for a particular purpose, or non-infringement.
      </p>

      <h2>11. User Responsibilities</h2>
      <ul>
        <li>
          • Ensure your use of the Service complies with all applicable laws and
          regulations.
        </li>
        <li>
          • Do not upload or share content that is defamatory, obscene, or
          infringes on intellectual property rights.
        </li>
      </ul>

      <h2>12. Termination</h2>
      <p>
        NeoSapien reserves the right to terminate your access to the Service if
        you violate these Terms. Upon termination, your rights to use the
        Service will cease immediately.
      </p>

      <h2>13. Governing Law and Dispute Resolution</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes shall be
        resolved through arbitration under the Arbitration and Conciliation Act,
        1996, with the venue in Bangalore, India. The language of arbitration
        shall be English.
      </p>

      <h2>14. Amendments</h2>
      <p>
        NeoSapien may update these Terms from time to time. Changes will be
        communicated via email or in-app notifications. Continued use of the
        Service after updates constitutes acceptance of the revised Terms.
      </p>

      <h2>15. Contact Information</h2>
      <p>
        For questions or concerns, please contact us at:
        <br />
        Email: support@neosapien.xyz
      </p>

      <h2>16. Indemnification</h2>
      <p>
        You agree to indemnify and hold NeoSapien harmless from claims, damages,
        or losses arising from your use of the Service, your violation of these
        Terms, or infringement of third-party rights.
      </p>

      <h2>17. Force Majeure</h2>
      <p>
        NeoSapien is not responsible for delays or failures due to events beyond
        its reasonable control, including but not limited to natural disasters,
        acts of government, or technical failures.
      </p>

      <p>
        By using Neo 1, you acknowledge that you have read, understood, and
        agreed to these Terms and Conditions.
      </p>
    </div>
  );
};

export default TermsAndConditions;
